// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxeth } from "../../../icons/full/build/icon-axeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxethIcon.displayName = 'AxethIcon';
}

export default AxethIcon;